(function () {
  function dbg(...args) {
    if (window.MF_MEDIA_DEBUG) console.log("[MF MEDIA]", ...args);
  }

  function findSectionId() {
    const mg = document.querySelector("media-gallery[id^='MediaGallery-']");
    return mg ? mg.id.replace("MediaGallery-", "") : null;
  }

  function getRoot(sectionId) {
    return (
      document.getElementById("MainProduct-" + sectionId) ||
      document.querySelector("#shopify-section-" + sectionId) ||
      document
    );
  }

  function getVariantId(root) {
    const idInput = root.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
    return idInput && idInput.value ? String(idInput.value) : "";
  }

  function findProductJsonWithVariants(root) {
    const scripts = Array.from(root.querySelectorAll('script[type="application/json"]'));
    for (const s of scripts) {
      try {
        const data = JSON.parse(s.textContent || "{}");
        if (data && Array.isArray(data.variants) && data.variants.length) return data;
      } catch (e) {}
    }
    return null;
  }

  function getFeaturedMediaIdForVariant(productJson, variantId) {
    const v = productJson.variants.find(x => String(x.id) === String(variantId));
    if (!v) return null;

    // Different themes store this differently
    if (v.featured_media && v.featured_media.id) return String(v.featured_media.id);
    if (v.featured_image && v.featured_image.id) return String(v.featured_image.id);

    // Some store just "featured_media" as an id
    if (v.featured_media) return String(v.featured_media);

    return null;
  }

  function clickThumbForMedia(sectionId, featuredMediaId) {
    const mg = document.getElementById("MediaGallery-" + sectionId);
    if (!mg) return false;

    // Dawn style thumbnails
    const thumbItems = Array.from(mg.querySelectorAll("li.thumbnail-list__item"));
    if (!thumbItems.length) return false;

    // data-target often contains the media id at the end, or inside the string
    const match = thumbItems.find(li => {
      const t = li.getAttribute("data-target") || "";
      return t.includes(featuredMediaId);
    });

    if (!match) {
      dbg("No matching thumbnail found for media id", featuredMediaId);
      return false;
    }

    const btn = match.querySelector("button.thumbnail, button, a");
    if (btn) {
      btn.click();
      return true;
    }

    return false;
  }

  function apply() {
    const sectionId = findSectionId();
    if (!sectionId) return;

    const root = getRoot(sectionId);
    const variantId = getVariantId(root);
    if (!variantId) {
      dbg("No variant id found");
      return;
    }

    const productJson = findProductJsonWithVariants(root);
    if (!productJson) {
      dbg("No product JSON with variants found");
      return;
    }

    const featuredMediaId = getFeaturedMediaIdForVariant(productJson, variantId);
    dbg("Variant -> featured media", { variantId, featuredMediaId });

    if (!featuredMediaId) return;

    const ok = clickThumbForMedia(sectionId, featuredMediaId);
    dbg("Clicked thumb?", ok);
  }

  function init() {
    apply();

    const sectionId = findSectionId();
    if (!sectionId) return;

    const root = getRoot(sectionId);
    const idInput = root.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');

    // Works with custom pickers because they must update input[name="id"]
    if (idInput) {
      const obs = new MutationObserver(apply);
      obs.observe(idInput, { attributes: true, attributeFilter: ["value"] });
      idInput.addEventListener("change", apply);
    }

    // If theme fires a variant:change event, great
    document.addEventListener("variant:change", apply);
  }

  document.addEventListener("DOMContentLoaded", init);
})();
